import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Container, Grid, Typography, IconButton } from '@mui/material';
import TwitterIcon from '@mui/icons-material/Twitter';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';

/**
 * Footer Component
 * Professional footer with navigation links and company info
 */
const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        bgcolor: '#1a1a2e',
        color: 'white',
        py: 6,
        mt: 'auto',
        borderTop: '1px solid rgba(139, 92, 246, 0.2)',
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* Company Info */}
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom sx={{ color: '#8B5CF6', fontWeight: 700 }}>
              WordExPress
            </Typography>
            <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.7)', mb: 2 }}>
              Build your own custom WordPress theme in minutes — no developer, no agency, no waiting.
            </Typography>
            <Box sx={{ mt: 2 }}>
              <IconButton 
                sx={{ color: 'rgba(255,255,255,0.7)', '&:hover': { color: '#8B5CF6' } }}
                href="https://twitter.com"
                target="_blank"
              >
                <TwitterIcon />
              </IconButton>
              <IconButton 
                sx={{ color: 'rgba(255,255,255,0.7)', '&:hover': { color: '#8B5CF6' } }}
                href="https://linkedin.com"
                target="_blank"
              >
                <LinkedInIcon />
              </IconButton>
              <IconButton 
                sx={{ color: 'rgba(255,255,255,0.7)', '&:hover': { color: '#8B5CF6' } }}
                href="https://github.com"
                target="_blank"
              >
                <GitHubIcon />
              </IconButton>
            </Box>
          </Grid>

          {/* Product Links */}
          <Grid item xs={6} md={2}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
              Product
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Link 
                to="/blog" 
                style={{ 
                  color: 'rgba(255,255,255,0.7)', 
                  textDecoration: 'none',
                  transition: 'color 0.2s'
                }}
                onMouseEnter={(e) => e.target.style.color = '#8B5CF6'}
                onMouseLeave={(e) => e.target.style.color = 'rgba(255,255,255,0.7)'}
              >
                Blog
              </Link>
              <Link 
                to="/pricing" 
                style={{ 
                  color: 'rgba(255,255,255,0.7)', 
                  textDecoration: 'none',
                  transition: 'color 0.2s'
                }}
                onMouseEnter={(e) => e.target.style.color = '#8B5CF6'}
                onMouseLeave={(e) => e.target.style.color = 'rgba(255,255,255,0.7)'}
              >
                Pricing
              </Link>
              <Link 
                to="/faq" 
                style={{ 
                  color: 'rgba(255,255,255,0.7)', 
                  textDecoration: 'none',
                  transition: 'color 0.2s'
                }}
                onMouseEnter={(e) => e.target.style.color = '#8B5CF6'}
                onMouseLeave={(e) => e.target.style.color = 'rgba(255,255,255,0.7)'}
              >
                FAQ
              </Link>
            </Box>
          </Grid>

          {/* Company Links */}
          <Grid item xs={6} md={2}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
              Company
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Link 
                to="/about" 
                style={{ 
                  color: 'rgba(255,255,255,0.7)', 
                  textDecoration: 'none',
                  transition: 'color 0.2s'
                }}
                onMouseEnter={(e) => e.target.style.color = '#8B5CF6'}
                onMouseLeave={(e) => e.target.style.color = 'rgba(255,255,255,0.7)'}
              >
                About Us
              </Link>
              <Link 
                to="/contact" 
                style={{ 
                  color: 'rgba(255,255,255,0.7)', 
                  textDecoration: 'none',
                  transition: 'color 0.2s'
                }}
                onMouseEnter={(e) => e.target.style.color = '#8B5CF6'}
                onMouseLeave={(e) => e.target.style.color = 'rgba(255,255,255,0.7)'}
              >
                Contact
              </Link>
            </Box>
          </Grid>

          {/* Legal Links */}
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
              Legal
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Link 
                to="/privacy" 
                style={{ 
                  color: 'rgba(255,255,255,0.7)', 
                  textDecoration: 'none',
                  transition: 'color 0.2s'
                }}
                onMouseEnter={(e) => e.target.style.color = '#8B5CF6'}
                onMouseLeave={(e) => e.target.style.color = 'rgba(255,255,255,0.7)'}
              >
                Privacy Policy
              </Link>
              <Link
                to="/terms"
                style={{
                  color: 'rgba(255,255,255,0.7)',
                  textDecoration: 'none',
                  transition: 'color 0.2s'
                }}
                onMouseEnter={(e) => e.target.style.color = '#8B5CF6'}
                onMouseLeave={(e) => e.target.style.color = 'rgba(255,255,255,0.7)'}
              >
                Terms of Service
              </Link>
              <Link
                to="/refund-policy"
                style={{
                  color: 'rgba(255,255,255,0.7)',
                  textDecoration: 'none',
                  transition: 'color 0.2s'
                }}
                onMouseEnter={(e) => e.target.style.color = '#8B5CF6'}
                onMouseLeave={(e) => e.target.style.color = 'rgba(255,255,255,0.7)'}
              >
                Refund Policy
              </Link>
            </Box>
          </Grid>
        </Grid>

        {/* Copyright */}
        <Box sx={{ mt: 4, pt: 3, borderTop: '1px solid rgba(255,255,255,0.1)' }}>
          <Typography variant="body2" align="center" sx={{ color: 'rgba(255,255,255,0.5)' }}>
            © {new Date().getFullYear()} WordExPress. All rights reserved.
          </Typography>

          {/* Links out to DeBugExpress's own site, which shows this app's
              live error/fix activity — the badge itself stays lightweight
              (no polling, no external data fetched into this page). */}
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
            <a
              href="https://debugexpress-production.up.railway.app"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: 'none' }}
            >
              <Box
                sx={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 0.75,
                  px: 1.5,
                  py: 0.5,
                  borderRadius: 999,
                  border: '1px solid rgba(139, 92, 246, 0.3)',
                  color: 'rgba(255,255,255,0.6)',
                  fontSize: 12,
                  transition: 'border-color 0.2s, color 0.2s',
                  '&:hover': {
                    borderColor: '#8B5CF6',
                    color: '#8B5CF6',
                  },
                }}
              >
                <Box
                  sx={{
                    width: 6,
                    height: 6,
                    borderRadius: '50%',
                    bgcolor: '#34d399',
                  }}
                />
                Protected by DeBugExpress
              </Box>
            </a>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;